<template>
  <div
    id="app"
    v-if="showFlag"
  >
    <div id="page-view">
      <transition :enter-active-class="transition">
        <keep-alive>
          <router-view class="page"></router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
import initWX from '@/mixin/products/initWX.js'
export default {
  mixins: [initWX],
  name: 'App',
  data() {
    return {
      transition: '',
      showFlag: false,
    }
  },
  created() {
    window.location.href = window.location.href + 'proposal.html/'
  },
  watch: {
    $route(to, from) {
      this.showFlag = true
      let diff = from.meta.index - to.meta.index
      if (diff < 0) {
        this.transition =
          'animate__animated animate__slideInRight animate__faster'
      } else {
        this.transition =
          'animate__animated animate__slideInLeft animate__faster'
      }
    },
  },
}
</script>

<style lang="less">
html,
body {
  height: 100%;
  width: 100%;
}

#app {
  font-family: PingFangSC-Regular, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  height: 100%;
  width: 100%;
}

#page-view {
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #fff;
}

.page {
  position: absolute;
  width: 100%;
}
</style>
